export enum RoutePaths{
    ROOT = '/',
    AUTH = '/auth',
    HOME = '/home',
    LOGOUT = '/logout',
    NOT_FOUND = '/not-found',
    MY_ORDERS = '/home/my-orders',
    BURGER_BUILDER = '/home/burger-builder',
    CHECKOUT = '/home/burger-builder/checkout',
    DELIVERY_DATA = '/home/burger-builder/checkout/delivery-details'
}